module.exports = __webpack_public_path__ + "img/01.96337a04.png";